<div class="shareContainer">

  <div class="shareModalBox lowCoins">
    <div class="backArrowSection">
      <ion-icon (click)="dismiss()" name="close-outline"></ion-icon>
    </div>
    <div class="imgDiv">
      <div class="compliment-circle">
        <img class="compliment-logo" [src]="srcIcon" (error)="onImageError($event)" alt="">
      </div>
    </div>
    <span class="title-share">{{'recadinho' | translate}}</span>

    <div class="txt-description">
      {{ descriptionText }}
    </div>
    <br>
    <ion-button class="purchaseButton button-round" (click)="openCurrency()">
      {{'buyCarrots' | translate}}
    </ion-button>
    <span class="youOwnClass lowCoins">
      {{ 'youOwn' | translate }} {{ userData?.coins ?? 0 }} {{ 'carrots' | translate }}
    </span>
  </div>
</div>
